export default {
  form: {
    fullName: 'Vor- und Nachname',
    jobTitle: 'Stellenbezeichnung',
    mobile: 'Mobilnummer',
    phone: 'Telefonnummer',
    email: 'E-Mail-Adresse',
    fax: 'Fax',
    company: 'Hotel Name',
    address: 'Anschrift, Hausnummer',
    city: 'Postleitzahl, Ort',
    country: 'Land',
    facebookLink: 'Facebook Link',
    twitterLink: 'Twitter Link',
    youtubeLink: 'YouTube Link',
    instagramLink: 'Instagram Link',
    operatingCompanyName: 'Name der Betreibergesellschaft',
    operatingCompanyHeadquarter: 'Sitz der Gesellschaft',
    operatingCompanyRegistryCourt: 'Registergericht',
    operatingCompanyDirectors: 'Geschäftsführer',
    operatingCompanyVat: 'Umsatzsteuer ID Nummer'
  },
  addNewField: 'Neues Feld hinzufügen',
  editField: 'Bearbeitungsfeld',
  uploadImageDescription: 'Du kannst ein Bild hochladen oder den öffentlichen Link zu einem Bild hinzufügen'
};
